export type MicrophoneIconProps = {
  className?: string;
};

export default ({ className }: MicrophoneIconProps) => (
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 64 64" className={className}>
    <path
      d="M39.62,32.77c0,3.61-3.02,6.52-6.77,6.52c-3.75,0-6.77-2.91-6.77-6.52v-17.6c0-3.61,3.02-6.52,6.77-6.52
      c3.75,0,6.77,2.91,6.77,6.52V32.77z M32.85,44.18c6.41,0,11.6-5.11,11.6-11.41h4.64c0,8.05-6.06,14.67-13.93,15.79v7.03h-4.64v-7.03
      c-7.87-1.12-13.93-7.73-13.93-15.79h4.64C21.24,39.07,26.44,44.18,32.85,44.18z"
    />
  </svg>
);
